import styled from "@emotion/styled"
import { PropsWithChildren } from "react"
import { Button } from "./Button"
import { CloseIcon } from "./CloseIcon"
import { SubscribeForm } from "./SubscribeForm"
import { breakPoints } from "../config/theme"

const Base = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  background-color: white;
  min-width: 100%;
  border-radius: 4px;
  padding: 8px;
  max-height: 100vh;
  overflow-y: auto;

  @media only screen and (min-width: ${breakPoints.tablet}) {
    min-width: 400px;
  }

  .onFormSubmittedFeedback {
    width: 100% !important;
    height: 100% !important;
  }
`

const Header = styled.div`
  max-width: 100vw;
  position: sticky;
  top: 0px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

const CloseButton = styled(Button)`
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`

type SubscribePopupProps = PropsWithChildren<{
  isOpen: boolean
  questionsAndAnswers: string
  onClose: () => void
  onFormSubmit: () => void
}>

export const SubscribePopup: React.FC<SubscribePopupProps> = ({
  isOpen,
  questionsAndAnswers,
  onClose,
  onFormSubmit,
}) => {
  if (!isOpen) return null

  return (
    <Base>
      <Content>
        <Header>
          <CloseButton onClick={onClose}>
            <CloseIcon style={{ minWidth: 16, minHeight: 16 }} />
          </CloseButton>
        </Header>
        <SubscribeForm
          questionsAndAnswers={questionsAndAnswers}
          onFormSubmit={onFormSubmit}
        />
      </Content>
    </Base>
  )
}
